import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarDays, ScrollText, Sparkles } from "lucide-react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import { PROMOTIONS } from "../data/siteData";

export default function Promozioni() {
  return (
    <>
      <SEO
        title="Promozioni | Sisal Store Mestre, Padova, Sant'Angelo"
        description="Le promozioni autorizzate dei nostri Sisal Store di Mestre, Padova e Sant'Angelo di Piove di Sacco."
      />
      <section data-testid="promozioni-page" className="bg-slate-50 py-16 sm:py-24">
        <div className="container-x">
          <Reveal>
            <p className="overline-tag">Promozioni</p>
            <h1 className="mt-3 font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Le nostre promozioni
            </h1>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-500 sm:text-lg">
              Le eventuali promozioni autorizzate verranno pubblicate in questa pagina.
            </p>
          </Reveal>

          {PROMOTIONS.length === 0 ? (
            <Reveal delay={0.1}>
              <div className="mt-12 flex flex-col items-center gap-5 rounded-3xl border border-dashed border-slate-300 bg-white p-10 text-center sm:p-16">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-light text-brand-dark">
                  <Sparkles className="h-7 w-7" />
                </span>
                <h2 className="font-display text-xl font-bold uppercase tracking-tight text-ink">
                  Nessuna promozione attiva al momento
                </h2>
                <p className="max-w-md text-sm leading-relaxed text-slate-500 sm:text-base">
                  Torna a trovarci presto: quando saranno disponibili promozioni autorizzate, le
                  troverai pubblicate qui con tutti i dettagli e le condizioni.
                </p>
                <Link to="/contatti" data-testid="promozioni-contact-btn" className="btn btn-outline btn-md">
                  CONTATTACI PER INFORMAZIONI
                </Link>
              </div>
            </Reveal>
          ) : (
            <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {PROMOTIONS.map((p, i) => (
                <Reveal key={i} delay={i * 0.08}>
                  <article data-testid={`promo-card-${i}`} className="card-soft flex h-full flex-col overflow-hidden">
                    {p.image && (
                      <img src={p.image} alt={p.title} loading="lazy" className="aspect-[16/9] w-full object-cover" />
                    )}
                    <div className="flex flex-1 flex-col p-6">
                      <h2 className="font-display text-lg font-bold uppercase tracking-tight text-ink">{p.title}</h2>
                      <p className="mt-2 text-sm leading-relaxed text-slate-500">{p.description}</p>
                      {p.conditions && (
                        <p className="mt-4 flex items-start gap-2 text-xs text-slate-400">
                          <ScrollText className="mt-0.5 h-4 w-4 shrink-0" />
                          {p.conditions}
                        </p>
                      )}
                      {p.validity && (
                        <p className="mt-2 flex items-center gap-2 text-xs text-slate-400">
                          <CalendarDays className="h-4 w-4 shrink-0" />
                          {p.validity}
                        </p>
                      )}
                      {p.link && (
                        <a
                          href={p.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          data-testid={`promo-link-${i}`}
                          className="btn btn-primary btn-sm mt-6 w-full"
                        >
                          SCOPRI DI PIÙ
                          <ArrowUpRight className="h-4 w-4" />
                        </a>
                      )}
                    </div>
                  </article>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
